import { z } from "zod"

import type { Nullish } from "~/@types/generics"
import { getRevalidateTags } from "~/lib/constants"
import { logger } from "~/utils/logger"

const vimeoDataSchema = z.object({
  type: z.string(),
  version: z.string(),
  provider_name: z.string(),
  provider_url: z.string(),
  title: z.string(),
  author_name: z.string(),
  author_url: z.string(),
  is_plus: z.string(),
  account_type: z.string(),
  html: z.string(),
  width: z.number(),
  height: z.number(),
  duration: z.number(),
  description: z.string(),
  thumbnail_url: z.string(),
  thumbnail_width: z.number(),
  thumbnail_height: z.number(),
  thumbnail_url_with_play_button: z.string(),
  upload_date: z.string(),
  video_id: z.number(),
  uri: z.string(),
})

async function getVimeoData(url: Nullish<string>) {
  if (!url) return undefined

  try {
    const vimeoFetch = await fetch(`https://vimeo.com/api/oembed.json?url=${url}`, {
      next: {
        tags: getRevalidateTags("video", "vimeo"),
        revalidate: false,
      },
    })
    const vimeoData = await vimeoFetch.json()

    const safeVimeoData = vimeoDataSchema.safeParse(vimeoData)

    if (safeVimeoData.success === false) return undefined

    return safeVimeoData.data
  } catch (error) {
    logger.warn(error)
    return undefined
  }
}

export async function getVimeoVideoRatio(url: Nullish<string>) {
  const data = await getVimeoData(url)

  if (!data) return undefined

  return data.width / data.height
}

export async function getVimeoVideoThumbnail(url: Nullish<string>) {
  const data = await getVimeoData(url)

  const src = data?.thumbnail_url.split("_")[0]
  const alt = data?.title

  if (!src) return undefined

  return { src, alt }
}
